import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KenchikuKbn = props => {
  return <Dropdown.Static kubunKey='kenchiku_kbn' {...props} />
}
